import { Component, inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';
import { ModalController } from '@ionic/angular';
import {
  ConstructionDayReportType,
  ModalService,
  RouterService,
  StateService,
  ToolService,
  WorkDay,
  WorkingEntry,
} from 'projects/shared/src/public-api';
import { ContextMenuOption } from '../../models/context-menu-option';

@Component({
  selector: 'lib-hours-detail',
  templateUrl: './hours-detail.component.html',
  styleUrls: ['./hours-detail.component.scss'],
  standalone: false,
})
export class HoursDetailComponent implements OnInit {
  private translate = inject(TranslateService);

  user: string;
  date: string;
  id: string;
  workDay: WorkDay;

  constructor(
    public state: StateService,
    public route: ActivatedRoute,
    public tools: ToolService,
    public modalCtrl: ModalController,
    public routerService: RouterService,
    public modalService: ModalService
  ) {}

  ngOnInit() {
    this.state.workingDays$.subscribe((x) => {
      this.workDay = x.find((x) => x.id == this.id);
    });
  }

  cancel() {
    return this.modalCtrl.dismiss(null, 'cancel');
  }

  editWorkDay() {
    this.modalCtrl.dismiss('edit', 'confirm');
  }

  async deleteWorkDay() {
    await this.state.deleteWorkDay(this.workDay);
    await this.modalCtrl.dismiss('delete', 'confirm');
  }

  async openContextMenu(event: MouseEvent, workEntry: WorkingEntry) {
    let additionalOptions: ContextMenuOption[] = [];
    if (
      this.state.userHasMinType(1) &&
      workEntry?.approvedBy == null &&
      !workEntry.createdByReport
    ) {
      additionalOptions.push({
        icon: 'time-outline',
        label: this.translate.instant('reports.createFromHours'),
        value: 'create-report',
      });
    }

    if (workEntry.createdByReport) {
      additionalOptions.push({
        icon: 'clipboard-outline',
        label: this.translate.instant('reports.openDaily'),
        value: 'open-report',
      });
    }

    const { data, role } = await this.state.openPopover(
      event,
      false,
      additionalOptions
    );
    if (!data) return;
    if (data == 'create-report') {
      const createAndConfirm = this.translate.instant(
        'reports.createAndConfirm'
      );
      await this.tools
        .showBasicAlert(
          this.translate.instant('reports.createFromHoursMessage'),
          this.translate.instant('reports.createFromHoursHeader'),
          this.translate.instant('common.create'),
          createAndConfirm
        )
        .then((x) => {
          if (x != 'backdrop') {
            let approve = x == createAndConfirm;
            this.state.createReportByWorkEntry(
              workEntry.id,
              ConstructionDayReportType.$2,
              approve
            );
          }
        });
    } else if (data == 'open-report') {
      await this.openReport(workEntry);
    }
  }

  async openReport(workEntry: WorkingEntry) {
    if (workEntry.createdByReport) {
      await this.modalService.openConstructionDayReportDetailModal(
        workEntry.createdBy,
        this.state.isBigScreen
      );
    }
  }
}
